export function milesToMeters(miles: number): number {
  return miles * 1609.34;
}
